/** @format */

import React, { useEffect, useState } from "react";
import styles from "../css/MaintenancePage.module.css";

export default function MaintenancePage() {
  const [announcement, setAnnouncement] = useState({
    title: "โปรดทราบ",
    normal_message: "เกิดข้อผิดพลาดที่ไม่คาดคิด ขออภัยในความไม่สะดวกครับ",
    highlight_message: "",
    url: "",
    created_at: "",
    type: "error",
  });

  useEffect(() => {
    const API_URL = "https://api.traffy.in.th/greeting-api/status";

    fetch(API_URL)
      .then((res) => {
        if (!res.ok) {
          console.error("API greeting error:", res.status, res.statusText);
          throw new Error(`HTTP ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        if (data) {
          setAnnouncement(data);
        }
      })
      .catch((err) => {
        console.error("Fetch greeting failed:", err);
      });
  }, []);

  const formatThaiDateTime = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);
    const day = date.getDate();
    const monthNames = [
      "ม.ค.",
      "ก.พ.",
      "มี.ค.",
      "เม.ย.",
      "พ.ค.",
      "มิ.ย.",
      "ก.ค.",
      "ส.ค.",
      "ก.ย.",
      "ต.ค.",
      "พ.ย.",
      "ธ.ค.",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear() + 543;
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${day} ${month} ${year} ${hours}:${minutes}น.`;
  };

  return (
    <div className={styles.container} style={{ fontFamily: "Noto Sans Thai" }}>
      <main className={styles.main} aria-live="polite">
        <div
          className={styles.iconWrapper}
          role="img"
          aria-label="ไอคอนกำลังปรับปรุงระบบ">
          <img
            src="/icon/coding.gif"
            alt="Coding Icon"
            className={styles.icon}
          />
        </div>

        <h1 className={styles.title}>{announcement.title}</h1>

        <p className={styles.message}>{announcement.normal_message}</p>

        {announcement.highlight_message && (
          <div className={styles.alert} role="alert">
            <p className={styles.alertLabel}>
              ช่วงเวลาที่ระบบไม่สามารถใช้งานได้:
            </p>
            <p>
              <strong>{announcement.highlight_message}</strong>
            </p>
          </div>
        )}

        <div className={styles.buttonGrid}>
          {announcement.url && (
            <a
              href={announcement.url}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.detailButton}>
              <svg
                className={styles.svgIcon}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                strokeWidth={2}>
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              <span>ดูรายละเอียด</span>
            </a>
          )}

          <a
            href="line://ti/p/@fonduehelp?oat_referrer=PROFILE"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.lineButton}>
            <svg
              className={styles.svgIcon}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              strokeWidth={2}>
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
              />
            </svg>
            <span>สอบถามทาง LINE</span>
          </a>
        </div>

        <div className={styles.footer}>
          <p>© Traffy Fondue</p>
          {announcement.created_at && (
            <p className={styles.timestamp}>
              ประกาศเมื่อ {formatThaiDateTime(announcement.created_at)}
            </p>
          )}
        </div>
      </main>
    </div>
  );
}
